import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const AlipayResult = () => {
  return <CommonResult />;
};

export default AlipayResult;
